import { Avatar, Text } from '@factorialco/deprecated-design-system'
import { AccessAndEmployeeInfoFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

export const EnrolledEmployees = ({
  employee,
  onlyAvatar = false,
}: {
  employee: AccessAndEmployeeInfoFragment | null | undefined
  onlyAvatar?: boolean
}) => {
  if (employee) {
    const employee_object = {
      id: employee.id,
      preferredName: employee.preferredName,
      access: {
        fullName: employee.fullName,
        avatar: employee.avatar?.url,
      },
    }
    if (onlyAvatar) {
      return (
        <Avatar
          size="s32"
          url={buildUrl(employee_object.access.avatar)}
          label={employee_object.access.fullName}
        />
      )
    } else {
      return <InlineEmployee employee={employee_object} variant="medium" linkProfile />
    }
  } else {
    return (
      <Text.Normal>
        {i18n.t('trainings.trainings_revamp.training_detail.employees_table.unknown')}
      </Text.Normal>
    )
  }
}
